import * as React from "react";
import { vodafoneFont } from "../api/data";
import { tealiumDataLayerPush } from '../utility/utility';
import { Divider } from "@material-ui/core";
import "../styles/vStyles.css";

export function hasNoServerError(vodafoneIcon: any) {
  return <div style={{ width: '730px', paddingLeft: "2%", verticalAlign: "left", textAlign: "left", fontFamily: vodafoneFont }}>
    <br />
    <table style={{ height: "387px", width: "100%", border: "0", borderStyle: "none" }}>
      <tbody>
        <tr style={{ height: "50px" }}>
          <td style={{ width: "50px", height: "50px" }}>
            <a href="https://www.unitymedia.de/">
              <img src={vodafoneIcon} height="50px" width="50px" ></img>
            </a>
          </td>
          <td style={{ width: "100%", height: "50px" }}></td>
        </tr>
        <tr>
          <td style={{ width: "50px" }}></td>
          <td style={{ width: "100%", height: "50px" }}>
            <p>Hallo Vodafone-Kund:in,</p>
            <p><br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.</p>
            <p><br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen.</p>
            <p><br />Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.</p>
            <p><br />Vielen Dank für dein Verständnis.</p>
            <p><br />Freundliche Grüße</p>
            <p><br />Dein Vodafone-Team</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>;
}

export function ErrorResponseFromAnypoint(error, vodafoneIcon) {
  tealiumDataLayerPush('pageview', { message: "contact customer care", type: "notification" }, {}, { siteStructureElement: ["contact customer care error"] }, {}).then();
  return hasNoServerError(vodafoneIcon);
  if (error?.status > 400 && error?.status < 500) { // 1.1	Case 1 only Ticketstatus is available on Landingpage
    return hasNoServerError(vodafoneIcon);
  }
  if (error?.status > 499) { // Token issues
    return <div style={{ width: '80%', margin: 'auto', paddingLeft: "2%", border: "solid", verticalAlign: "middle", textAlign: "center" }}>
      <br />
      <img src={vodafoneIcon} style={{ width: "50px", height: "50px" }}></img>
      <p>
          Hallo Vodafone-Kund:in,
        <br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.
        <br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen. 
        <br/>Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.
        <br />Vielen Dank für dein Verständnis.
        <br />Freundliche Grüße
        <br />Dein Vodafone-Team
      </p></div>;
  }
  return hasNoServerError(vodafoneIcon);
}

export function appointmentError(type: String) {
  if (type.toLowerCase() === 'standard')
    return (
      <>
        <text>
          Hallo Vodafone-Kund:in,
        <br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.
        <br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen. 
        <br/>Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.
        <br />Vielen Dank für dein Verständnis.
        <br />Freundliche Grüße
        <br />Dein Vodafone-Team
      </text>
      </>
    )

  if (type.toLowerCase() === 'special') {
    return (
      <>
        <text>
          Hallo Vodafone-Kund:in,
        <br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.
        <br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen. 
        <br/>Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.
        <br />Vielen Dank für dein Verständnis.
        <br />Freundliche Grüße
        <br />Dein Vodafone-Team
        </text>
      </>
    )
  }
}
export function mapsErrorMessage(companyName, technicianPhone, paperPenMid, networkInterenetMid, technicianName = null) {
  return (
    <div className={'error_error-screen swa-gen-font-style'}>
      <article style={{ paddingBottom: '1em' }}>
        <p>Dein Techniker ist auf dem Weg zu dir</p>
        <p>Leider können wir im Moment nicht anzeigen, wo sich der Techniker befindet.</p>
      </article>
      <Divider variant="middle"></Divider>
      {technicianName && <strong style={{ paddingTop: '0.5em' }}>{technicianName}</strong>}
      <div className={'swa-gen-flex-row center gap2 saw-gen-padding-halfem'}>
        <div className={'swa-gen-flex-row gap1'}>
          <img className="map_icon" src={paperPenMid} />
          <div className="map_text">{companyName}</div>
        </div>
        <div className={'swa-gen-flex-row gap1'}>
          <img className="map_icon" src={networkInterenetMid} />
          <div className="map_phone-text">{technicianPhone}</div>
        </div>
      </div>
      <Divider variant="middle"></Divider>
    </div>
  )
}
